import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const CustomerLayout = loadable(() => import('./customer.layout'), {
  fallback: <FullPageLoader />,
});
export const AddressLayout = loadable(() => import('./address.layout'), {
  fallback: <FullPageLoader />,
});
